import React from 'react'
import { AppContext } from '../../context'

const TrialControl: React.FC = ({}) => {
  return (
    <AppContext.Consumer>
      {({ activePopover, onTogglePopover }) => (
        <div className="mapboxgl-ctrl mapboxgl-ctrl-trial-info-container">
          <div
            className={`mapboxgl-ctrl-trial-info material-icons ${
              activePopover === 'trial' ? 'on' : ''
            }`}
            onClick={() => onTogglePopover('trial')}
          >
            help_outline
          </div>
        </div>
      )}
    </AppContext.Consumer>
  )
}

export default TrialControl
